import { render, staticRenderFns } from "./CrgoConveyance.vue?vue&type=template&id=61e278fd&"
import script from "./CrgoConveyance.vue?vue&type=script&lang=js&"
export * from "./CrgoConveyance.vue?vue&type=script&lang=js&"
import style0 from "./CrgoConveyance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrgoConveyance.vue"
export default component.exports